<template>
  <div class="home">
    <div v-loading="loading" element-loading-text="加载中..." style="min-height: calc(100vh - 106px);" v-if="!error">
      <!-- Hero Banner Carousel -->
      <section class="hero-banner">
        <div class="carousel-container">
          <div class="carousel-track" :style="{ transform: `translateX(-${bannerMark * 100}%)` }">
            <!-- Slide 1: 原始 Banner 内容 -->
            <div class="carousel-slide slide-original">
              <div class="slide-bg" style="background: url('https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/match/bg_banner_1.jpg') center center / cover no-repeat;"></div>
              <div class="hero-overlay"></div>
              <div class="hero-content w">
                <div class="hero-text">
                  <h1 class="hero-title">AI智能化设计服务</h1>
                  <p class="hero-subtitle">数字化口腔智能制造平台</p>
                </div>
              </div>
            </div>
            <!-- Slide 2: AI 智能设计 -->
            <div class="carousel-slide slide-ai">
              <div class="slide-bg" style="background: url('https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/match/bg_banner_2.jpg') center center / cover no-repeat;"></div>
              <div class="hero-content w">
                <div class="hero-text">
                  <h1 class="hero-title">全自动智能AI生产线</h1>
                  <p class="hero-subtitle">齿科数字<span class="hl-blue">新基建</span></p>
                </div>
              </div>
            </div>
          </div>
          <!-- Carousel Indicators -->
          <div class="carousel-indicators">
            <span v-for="i in 2" :key="i" :class="{ active: bannerMark === i - 1 }" @click="bannerMark = i - 1"></span>
          </div>
          <!-- Carousel Arrows -->
          <button class="carousel-arrow carousel-prev" @click="prevBanner">
            <i class="el-icon-arrow-left"></i>
          </button>
          <button class="carousel-arrow carousel-next" @click="nextBanner">
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
      </section>
      <section class="activity-panel w reveal-on-scroll" data-reveal="fade-up">
        <div class="catalog-grid">
          <div class="catalog-item" v-for="(item,j) in catalogList" :key="j" @click="linkToCatalog(j)">
            <img class="catalog-img" :src="item.iconSelect" :alt="item.name">
            <span class="catalog-name">{{item.name}}</span>
          </div>
        </div>
      </section>
      <section class="news-panel w reveal-on-scroll" data-reveal="fade-up">
        <div class="news-showcase">
          <!-- 左侧：产品图片轮播 -->
          <div class="news-left">
            <div class="news-left-carousel">
              <div
                v-for="(item, i) in showcaseList"
                :key="i"
                class="news-slide"
                :class="{ active: showcaseMark === i }"
                @click="onShowcaseClick(item)"
              >
                <img v-if="item.__src" :src="item.__src" :alt="item.newsTitle">
              </div>
              <div v-if="showcaseList.length === 0" class="news-left-empty">
                <i class="el-icon-picture-outline"></i>
                <p>暂无热点新闻</p>
              </div>
            </div>
            <div class="news-left-indicators">
              <span
                v-for="(item, i) in showcaseList"
                :key="i"
                :class="{ active: showcaseMark === i }"
                @click="showcaseMark = i"
              ></span>
            </div>
          </div>
          <!-- 右侧：行业新闻 -->
          <div class="news-right">
            <div class="news-header">
              <h2>行业新闻</h2>
              <span class="news-en">NEWS & INFORMATION</span>
            </div>
            <ul class="news-list">
              <li v-for="(item, i) in newsList" :key="item.newsId !== undefined ? item.newsId : i" @click="onShowcaseClick(item)">
                <span class="news-date">{{ formatNewsDate(item.newsTime) }}</span>
                <span class="news-title">{{ item.newsTitle }}</span>
                <span class="news-arrow">→</span>
              </li>
              <li v-if="newsList.length === 0" class="news-empty">暂无新闻</li>
            </ul>
          </div>
        </div>
      </section>
      <section class="mall-panel w reveal-on-scroll" data-reveal="fade-up" style="margin-top: 50px;">
        <div class="section-title">
          <h1>功能中心</h1>
          <span class="title-en">FUNCTION CENTER</span>
          <div class="title-bar"></div>
        </div>
        <div class="mall-panel-box">
          <ul class="left-box">
            <li v-for="(item, index) in mallList" :key="index" @click="onMallClick(item)">
              <div class="mall-card">
                <div class="mall-card-img">
                  <img :src="item.bg" :alt="item.name">
                </div>
                <div class="mall-card-text">
                  <h3 class="mall-card-name">{{ item.name }}</h3>
                  <span class="mall-card-en">{{ item.enName }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>

      <section class="about-panel w reveal-on-scroll" data-reveal="fade-up">
        <div class="section-title">
          <h1>关于医小智</h1>
          <span class="title-en">ABOUT US</span>
          <div class="title-bar"></div>
        </div>
        <div class="footer-main">
          <div class="footer-intro">
            <h3>尊敬的用户，您好!</h3>
            <p>医小智为您带来全新的齿科在线设计服务，不管您什么时间需要，多远的距离需要，都可以在医小智享受专业高效的义齿设计服务。</p>
            <p>10秒内完成下单，5分钟反馈数字化扫描数据品质，实时更新临床信息，30分钟完成数字化线上设计，输出制造文件和治疗方案，24小时内免费修改设计方案。</p>
            <p><strong>我们的目标是帮助您及您的客户打造一口健康、美丽的牙齿，让您自信地展开笑容!</strong></p>
          </div>
          <div class="footer-bottom">
            <div class="footer-contact">
              <div class="contact-item">
                <i class="el-icon-phone-outline"></i>
                <div>
                  <strong>服务热线</strong>
                  <span>400 088 3316</span>
                </div>
              </div>
              <div class="contact-item">
                <i class="el-icon-time"></i>
                <div>
                  <strong>服务时间</strong>
                  <span>每天 8:30 ~ 21:30</span>
                </div>
              </div>
            </div>
<!--            <div class="footer-qrcode">-->
<!--              <div class="qr-item">-->
<!--                <div class="qr-popup">-->
<!--                  <img src="/static/images/qr_wx_code.png" alt="微信公众号">-->
<!--                </div>-->
<!--                <div class="qr-icon">-->
<!--                  <img src="/static/images/order/catalog/img56_2.png" alt="微信">-->
<!--                </div>-->
<!--                <span>微信公众号</span>-->
<!--              </div>-->
<!--              <div class="qr-item">-->
<!--                <div class="qr-popup">-->
<!--                  <img src="/static/images/qr_wx_code.png" alt="抖音">-->
<!--                </div>-->
<!--                <div class="qr-icon">-->
<!--                  <img src="/static/images/order/catalog/img56_4.png" alt="抖音">-->
<!--                </div>-->
<!--                <span>抖音号</span>-->
<!--              </div>-->
<!--              <div class="qr-item">-->
<!--                <div class="qr-popup">-->
<!--                  <img src="/static/images/qr_wx_code.png" alt="快手">-->
<!--                </div>-->
<!--                <div class="qr-icon">-->
<!--                  <img src="/static/images/order/catalog/img56_3.png" alt="快手">-->
<!--                </div>-->
<!--                <span>快手号</span>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </section>

      <section class="link-panel w reveal-on-scroll" data-reveal="fade-up">
        <div class="link-box">
          <a v-for="(item,index) in cataList" :key="index" class="link-tile" @click="openAgree(item.id)">
            <div class="link-icon-wrap">
              <i :class="item.icon"></i>
            </div>
            <span>{{item.item}}</span>
          </a>
        </div>
      </section>
    </div>
    <div class="no-info" v-if="error">
      <div class="no-data">
        <img src="/static/images/error.png">
        <br> 抱歉！出错了...
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="600px" center>
      <div slot="title" class="header-title">
        <div style="padding:15px 20px;">认证申请</div>
      </div>
      <!-- <div style=""> -->
      <div style="display: flex; align-items: center; justify-content:space-around;height: 300px;">
        <div class="item itme1">
          <a @click="factory">
            <div class="t fiex f-18">
              <div class="t2 center"><img src="/static/images/zc11.png">
                <!-- <p class="mag-t-20">认证诊所/工厂进行下单</p> -->
              </div>
            </div>
            <div class="p">诊所/工厂认证</div>
          </a>
        </div>
        <div class="item itme2">
          <a @click="designer">
            <div class="t fiex f-18">
              <div class="t2 center"><img src="/static/images/zc22.png">
                <!-- <p class="mag-t-20">认证成为设计师进行接单</p> -->
              </div>
            </div>
            <div class="p">设计师认证</div>
          </a>
        </div>
      </div>
      <!-- </div> -->
    </el-dialog>
    <tools class="tools" style="display: block;"></tools>
  </div>
</template>
<script>
import bannerData from "/assets/config/home/banner.js";
import catalogData from "/assets/config/order/catalogList.js";
import goodsData from "/assets/config/goodsList.js";
import mallGoods from '/components/mallGoods'
import tools from '../Home/tools'
import {
  setStore,
  getStore
} from '/utils/storage.js'
import {
  getImgSrc,
  cacheImg
} from '/utils/imgCache.js'
import yxz_config from '../../../common/config/config.js'
import {
  mapState
} from 'vuex'

export default {
  data() {
    return {
      loading: true,
      error: false,

      bannerList: [],
      catalogList: [],
      goodsList: [],
      poster:[
        {label:'新技术'},
        {label:'新材料'},
        {label:'设备上新'},
        {label:'行业动向'},
        // {label:'赛事资讯'},
        // {label:'作品提交'},
      ],
      mark: 0,
      bannerMark: 0,
      bgOpt: {
        px: 0,
        py: 0,
        w: 0,
        h: 0
      },
      timer: '',
      dialogVisible: false,
      revealObserver: null,
      linkColors: ['#1890ff','#36cfc9','#722ed1','#eb2f96','#fa8c16','#52c41a','#13c2c2','#2f54eb','#f5222d'],
      get linkColumns() {
        const half = Math.ceil(this.cataList.length / 2);
        return [this.cataList.slice(0, half), this.cataList.slice(half)];
      },
      cataList:[
        {item:'在线软件',icon:'el-icon-s-promotion',id:'23'},
        {item:'软件下载',icon:'el-icon-download',id:'24'},
        {item:'合作介绍',icon:'el-icon-monitor',id:'21'},
        {item:'医患沟通应用介绍',icon:'el-icon-document-copy',id:'25'},
        {item:'设计说明',icon:'el-icon-cpu',id:'12'},
        {item:'售后服务',icon:'el-icon-box',id:'13'},
        {item:'下单操作流程',icon:'el-icon-sold-out',id:'15'},
        {item:'接单操作流程',icon:'el-icon-sell',id:'16'},
        {item:'固定模块说明',icon:'el-icon-coin',id:'18'},
        {item:'种植模块说明',icon:'el-icon-price-tag',id:'17'},
        {item:'联系方式',icon:'el-icon-phone-outline',id:'31'},
        {item:'企业招聘',icon:'el-icon-user',id:'32'},
        {item:'荣誉奖项',icon:'el-icon-s-management',id:'33'},
        {item:'线上培训',icon:'el-icon-top',id:'34'},
        {item:'线下培训',icon:'el-icon-bottom',id:'35'},
        {item:'有关医小智',icon:'el-icon-reading',id:'41'},
        {item:'投诉与反馈',icon:'el-icon-edit-outline',id:'43'},
        {item:'在线客服',icon:'el-icon-headset',id:'44'},
      ],
      mallList:[
        {name:'AI 设计',enName:'AI Design',desc:'智能辅助，高效完成修复体设计',icon:'el-icon-magic-stick',color:'#24d1bc',path:'/aides',bg:'/static/images/order/catalog/home_select_1.png'},
        {name:'AI 智造',enName:'AI Manufacturing',desc:'人工智能驱动的智能分析系统',icon:'el-icon-monitor',color:'#ff5459',path:'/aides',bg:'/static/images/order/catalog/home_select_2.png'},
        {name:'商城',enName:'Mall Center',desc:'优质口腔材料与设备一站式采购',icon:'el-icon-shopping-cart-2',color:'#3971ff',path:'/mall',bg:'/static/images/order/catalog/home_select_3.png'},
        {name:'案例展示',enName:'Showcase',desc:'精选优秀临床案例与作品展示',icon:'el-icon-picture-outline',color:'#6bc25a',path:'/showcase',bg:'/static/images/order/catalog/home_select_5.png'},
        {name:'服务',enName:'Service',desc:'全方位技术支持与售后服务',icon:'el-icon-service',color:'#00bd56',path:'/service',bg:'/static/images/order/catalog/home_select_6.png'},
      ],
      newsList:[],
      showcaseList:[],
      showcaseMark: 0,
      showcaseTimer: '',
      showTooltip: false,
      message: '这是一个指向 header 的提示窗口',
      showArrowUp: true,
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    linkToNews(index) {
      // 判断是否登陆/认证

      if (this.user.isLogin) {

        if (this.user.userType === '99' || this.user.authFlag == '99') {
          this.$yxz.msg('账号未认证或认证被驳回，请提交认证资料', 'error')

          if (this.user.authFlag == '00') {
            this.dialogVisible = true
            return false;
          }
          if (this.user.authFlag == '02') {
            this.dialogVisible = true
            return false;
          }
          if (this.user.authFlag == '99') {
            this.dialogVisible = true
            return false;
          }
        } else {
          if (this.user.authFlag == '02') {
            this.$message({
              message: '您的认证信息正在审核中，请稍后重试...',
              type: 'success'
            });
          } else {
            let url = index == 0 ? '/agreement?agreeId=45' : '/match/upload';
            // if(index==1){
            //   localStorage.setItem('matchUpload','/match/upload');
            // }else{
            //   localStorage.setItem('matchUpload','/agreement?agreeId=45');
            // }
            localStorage.setItem('matchUpload', url);
            let routeUrl = this.$router.resolve({ path: url });
            window.open(routeUrl.href, '_blank');
          }
        }
      } else {

        this.$yxz.msg('未登录或登录状态已过期,请重新登录', 'error')
        var that = this;
        setTimeout(function () {
          that.$yxz.to('/login')
        }, 1500);

      }

      let url = index == 0 ? '/agreement?agreeId=45' : '/match/upload';
      // if(index==1){
      //   localStorage.setItem('matchUpload','/match/upload');
      // }else{
      //   localStorage.setItem('matchUpload','/agreement?agreeId=45');
      // }
      localStorage.setItem('matchUpload',url);
      let routeUrl = this.$router.resolve({path: url});
      window.open(routeUrl.href, '_blank');
    },
    formatNewsDate(newsTime) {
      if (!newsTime || typeof newsTime !== 'string') return ''
      return newsTime.slice(5, 10)
    },
    onShowcaseClick(item) {
      let routeUrl = this.$router.resolve({path: '/newsDetail', query: {newsId: item.newsId}});
      window.open(routeUrl.href, '_blank');
    },
    autoPlayShowcase() {
      this.showcaseMark++
      if (this.showcaseMark > this.showcaseList.length - 1) {
        this.showcaseMark = 0
      }
    },
    playShowcase() {
      // 每4s自动轮播
      this.showcaseTimer = setInterval(this.autoPlayShowcase, 4000)
    },
    stopShowcase() {
      clearInterval(this.showcaseTimer)
    },
    // news-left 轮播图本地缓存：命中缓存直接用本地图秒开，未命中先正常展示压缩图并后台写入缓存
    loadShowcaseImages() {
      this.showcaseList.forEach((item, index) => {
        // 相对路径补上 imgUrl 前缀，完整 http(s) 地址保持不变
        const fullUrl = item.picUrl && !/^https?:\/\//.test(item.picUrl) ? yxz_config.imgUrl + item.picUrl : item.picUrl
        getImgSrc(fullUrl).then((src) => {
          if (!this.showcaseList[index]) return
          this.$set(this.showcaseList[index], '__src', src)
          // 未命中缓存（非 blob 地址）：后台下载写入缓存，下次刷新秒开
          if (src.indexOf('blob:') !== 0) cacheImg(fullUrl)
        })
      })
    },
    // 字段兼容后端 content 实体命名
    mapContentRow(row) {
      return {
        ...row,
        newsId: row.contentId !== undefined ? row.contentId : (row.newsId !== undefined ? row.newsId : row.id),
        newsTitle: row.contentTitle || row.newsTitle || row.title || '',
        newsSubTitle: row.contentSubTitle || row.newsSubTitle || row.subTitle || row.summary || '',
        picUrl: row.image || row.picUrl || row.contentImage || row.imageUrl || '',
        newsTime: row.publishTime || row.newsTime || row.createTime || row.updateTime || '',
        isTop: row.isTop !== undefined ? row.isTop : (row.topFlag !== undefined ? row.topFlag : '0'),
      }
    },
    // 请求 news-showcase 数据源：左侧轮播 contentType=47，右侧列表 contentType=46
    getNewsShowcaseList() {
      // 左侧轮播
      this.$api.get({
        url: '/biz/content/list',
        data: {
          contentType: 47
        }
      }).then(res => {
        if (res.code !== 200) return
        const rows = res.rows || res.data || []
        this.showcaseList = (Array.isArray(rows) ? rows : []).map(this.mapContentRow)
        // 轮播图走本地缓存，刷新时无需重新下载
        this.loadShowcaseImages()
      }).catch(() => {})
      // 右侧列表
      this.$api.get({
        url: '/biz/content/list',
        data: {
          contentType: 46
        }
      }).then(res => {
        if (res.code !== 200) return
        const rows = res.rows || res.data || []
        this.newsList = (Array.isArray(rows) ? rows : []).map(this.mapContentRow).slice(0, 5)
      }).catch(() => {})
    },
    onMallClick(item) {
      if(item.path){
        let routeUrl = this.$router.resolve({path: item.path});
        window.open(routeUrl.href, '_blank');
      }
    },


    autoPlay() {
      this.mark++
      if (this.mark > this.bannerList.length - 1) {
        this.mark = 0
      }
    },
    play() {
      // 每2.5s自动切换
      this.timer = setInterval(this.autoPlay, 5000)
    },
    change(i) {
      this.mark = i
    },
    startTimer() {
      this.timer = setInterval(this.autoPlay, 5000)
    },
    stopTimer() {
      clearInterval(this.timer)
    },
    prevBanner() {
      this.bannerMark--
      if (this.bannerMark < 0) this.bannerMark = 1
    },
    nextBanner() {
      this.bannerMark++
      if (this.bannerMark > 1) this.bannerMark = 0
    },
    linkTo(item) {
      // window.open('//' + window.location.host + '/#/home')
    },
    linkToCatalog(index) {
      if (this.user.isLogin) {

        if (this.user.userType === '99'||this.user.authFlag == '99') {
          this.$yxz.msg('账号未认证或认证被驳回，请提交认证资料', 'error')

          if (this.user.authFlag == '00') {
            this.dialogVisible = true
          }
          if (this.user.authFlag == '02') {
            this.dialogVisible = true
          }
          if (this.user.authFlag == '99') {
            this.dialogVisible = true
          }
        }else{
          if(this.user.authFlag == '02'){
            this.$message({
              message: '您的认证信息正在审核中，请稍后重试...',
              type: 'success'
            });
          }else{
            if (this.user.userType === '10') {
              window.open('//' + window.location.host + '/#/order/create?catalogId=' + index)
            }
            if (this.user.userType === '20') {
              window.open('//' + window.location.host + '/#/order/mall')
            }
          }
        }
      } else {

        this.$yxz.msg('未登录或登录状态已过期,请重新登录', 'error')
        var that = this;
        setTimeout(function() {
          that.$yxz.to('/login')
        }, 1500);

      }

    },
    bgOver(e) {
      this.bgOpt.px = e.offsetLeft
      this.bgOpt.py = e.offsetTop
      this.bgOpt.w = e.offsetWidth
      this.bgOpt.h = e.offsetHeight
    },
    bgMove(dom, eve) {
      let bgOpt = this.bgOpt
      let X, Y
      let mouseX = eve.pageX - bgOpt.px
      let mouseY = eve.pageY - bgOpt.py
      if (mouseX > bgOpt.w / 2) {
        X = mouseX - (bgOpt.w / 2)
      } else {
        X = mouseX - (bgOpt.w / 2)
      }
      if (mouseY > bgOpt.h / 2) {
        Y = bgOpt.h / 2 - mouseY
      } else {
        Y = bgOpt.h / 2 - mouseY
      }
      dom.style['transform'] = `rotateY(${X / 50}deg) rotateX(${Y / 50}deg)`
      dom.style.transform = `rotateY(${X / 50}deg) rotateX(${Y / 50}deg)`
    },
    bgOut(dom) {
      dom.style['transform'] = 'rotateY(0deg) rotateX(0deg)'
      dom.style.transform = 'rotateY(0deg) rotateX(0deg)'
    },
    designer() {
      this.$yxz.to('/designerAuth')
      this.dialogVisible = false
    },
    factory() {
      this.$yxz.to('/factoryAuth')
      this.dialogVisible = false
    },
    openAgree(id) {
      if(id==24){
        let routeUrl = this.$router.resolve({path: '/downLoad'})
        window.open(routeUrl.href, '_blank');
      }else{
        let url = this.$router.replace({
          name:'agreement',
          query: {agreeId:id},
        })
        window.open(url,'_self')
      }
    },
    // 滚动进入视口动画
    initScrollReveal() {
      const sections = document.querySelectorAll('.reveal-on-scroll')
      if (!sections.length) return

      // rootMargin 向下扩展 150% 视口高度：模块还在屏幕下方 1.5 屏时就提前触发动画，
      // 保证用户滚动到该位置时内容已加载展示完毕，不会出现“进入页面还没加载出来”的情况
      this.revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed')
            this.revealObserver.unobserve(entry.target)
          }
        })
      }, {
        threshold: 0,
        rootMargin: '0px 0px 150% 0px'
      })

      sections.forEach(section => {
        this.revealObserver.observe(section)
      })
    }
  },
  mounted() {
    this.$yxz.title("医小智 - 首页")
    if(localStorage.getItem('matchUpload')){
      let url = localStorage.getItem('matchUpload');
      localStorage.removeItem('matchUpload');
      this.$router.push(url);
    }
    // 滚动进入视口动画
    this.$nextTick(() => {
      this.initScrollReveal()
    })
  },
  beforeDestroy() {
    if (this.revealObserver) {
      this.revealObserver.disconnect()
    }
    this.stopShowcase()
  },
  created() {
    this.bannerList = bannerData;
    this.goodsList = goodsData;
    this.catalogList = catalogData;
    // news-showcase 数据源：biz/content/24 接口
    this.getNewsShowcaseList();
    this.loading = false;
    this.play()
    this.playShowcase()
  },
  components: {
    mallGoods,
    tools
  }
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  color: #333;
}

.no-info {
  padding: 100px 0;
  text-align: center;
  font-size: 30px;
  display: flex;
  flex-direction: column;

  .no-data {
    align-self: center;
  }
}

/* ===== Hero Banner Carousel ===== */
.hero-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-container {
  position: relative;
  width: 100%;
  height: 360px;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  height: 100%;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.carousel-slide {
  min-width: 100%;
  height: 100%;
  position: relative;
}

/* Slide 1: Original Banner */
.slide-original {
  background: linear-gradient(135deg, #e8f4f8 0%, #d4eaf7 30%, #e0d4f7 70%, #f0e6f6 100%);
  display: flex;
  align-items: center;

  .hero-overlay {
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse at 20% 50%, rgba(0, 165, 213, 0.12) 0%, transparent 60%),
      radial-gradient(ellipse at 80% 50%, rgba(102, 126, 234, 0.08) 0%, transparent 60%);
  }
}

/* Slide 1 & 2 共用文字布局 */
.slide-original,
.slide-ai {
  .hero-content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .hero-text {
    margin-left: 160px;

    .hero-title {
      font-size: 38px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.45);
      margin: 0 0 12px 0;
      letter-spacing: 2px;
    }
    .hero-subtitle {
      font-size: 18px;
      color: rgba(0, 0, 0, 0.45);
      margin: 0;
      letter-spacing: 4px;
    }
  }
}

/* 第一屏标题字体颜色覆盖（需置于共用规则之后才能生效） */
.slide-original .hero-text .hero-title {
  color: #085AE1;
}

/* 第二屏副标题中“新基建”三字字体颜色 */
.slide-ai .hero-text .hero-subtitle .hl-blue {
  color: #085AE1;
  font-size: 23px;
  font-weight:bold ;
}

/* Slide 2 & 3: Product Slides */
.slide-bg {
  position: absolute;
  inset: 0;
}

.slide-content {
  position: relative;
  z-index: 2;
  height: 100%;
  padding: 0 60px;
}

.slide-btn {
  position: absolute;
  bottom: 32px;
  right: 60px;
  padding: 14px 32px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 28px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  z-index: 3;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }
}

.slide-text {
  max-width: 500px;

  .slide-title {
    font-size: 42px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 16px 0;
    letter-spacing: 2px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  .slide-desc {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.9);
    margin: 0 0 28px 0;
    line-height: 1.7;
  }

  .slide-btn {
    padding: 14px 32px;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 28px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    }
  }
}

.slide-visual {
  width: 380px;
  height: 240px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/* Carousel Controls */
.carousel-indicators {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;

  span {
    width: 32px;
    height: 4px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 2px;
    cursor: pointer;
    transition: all 0.3s ease;

    &.active {
      background: #fff;
      width: 48px;
    }
  }
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-50%) scale(1.1);
  }
}

.carousel-prev {
  left: 24px;
}

.carousel-next {
  right: 24px;
}

/* ===== Activity / Catalog Panel ===== */
.activity-panel {
  margin: 0 auto;
  padding: 50px 0 0;

  .catalog-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }

  .catalog-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0 18px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: radial-gradient(circle at center, transparent 0%, transparent 40%, rgba(0, 183, 237, 0.07) 100%);
    box-shadow: inset 0 0 38px rgba(0, 183, 237, 0.23);

    &:hover {
      background: radial-gradient(circle at center, transparent 0%, transparent 40%, rgba(0, 183, 237, 0.12) 100%);
      transform: translateY(-3px);
      box-shadow: inset 0 0 38px rgba(0, 183, 237, 0.35);

      .catalog-name {
        color: #1890ff;
      }
    }

    .catalog-img {
      width: 190px;
      height: 125px;
      object-fit: contain;
      margin-bottom: 10px;
      transition: transform 0.3s ease;
    }

    &:hover .catalog-img {
      transform: scale(1.03);
    }

    .catalog-name {
      font-size: 22px;
      color: #00A4D4;
      letter-spacing: 1px;
      transition: color 0.3s ease;
    }
  }
}

.mall-panel {
  margin: 15px auto;
  margin-bottom: 80px;
  position: relative;
}

.mall-panel-box {
  width: 100%;
  box-sizing: border-box;
}

.left-box {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    cursor: pointer;
    position: relative;
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

    &:hover {
      transform: translateY(-8px) scale(1.05);
    }
  }
}

.mall-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  transition: filter 0.4s ease;

  li:hover & {
    filter: brightness(1.02);
  }
}

.mall-card-img {
  width: calc(100% - 20px);
  margin: 10px;
  aspect-ratio: 1;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    transition: transform 0.4s ease;
  }

  li:hover & img {
    transform: scale(1.06);
  }
}

.mall-card-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 10px 14px;
}

.mall-card-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
  transition: color 0.3s ease;

  li:hover & {
    color: #1890ff;
  }
}

.mall-card-en {
  font-size: 12px;
  color: #999;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;

  li:hover & {
    color: #1890ff;
  }
}

.news-panel {
  margin: 50px auto 0;
  position: relative;
}

.news-showcase {
  display: flex;
  gap: 24px;
  align-items: stretch;
}

.news-left {
  flex: 0 0 calc(58% - 12px);
  width: calc(58% - 12px);
  box-sizing: border-box;
  min-width: 0;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s ease;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .news-left-carousel {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 280px;
  }

  .news-left-empty {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    background: #f5f7fa;
    color: #bbb;
    cursor: default;

    i {
      font-size: 56px;
    }

    p {
      margin: 0;
      font-size: 14px;
      letter-spacing: 2px;
    }
  }

  .news-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.6s ease;

    &.active {
      opacity: 1;
      pointer-events: auto;
    }
  }

  .news-left-indicators {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 5;

    span {
      width: 24px;
      height: 4px;
      background: rgba(255, 255, 255, 0.45);
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        background: #fff;
        width: 36px;
      }
    }
  }

}

.news-right {
  flex: 0 0 calc(42% - 12px);
  width: calc(42% - 12px);
  height: 430px;
  box-sizing: border-box;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  padding: 28px 32px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.news-header {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    font-size: 20px;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0 0 6px 0;
  }

  .news-en {
    font-size: 11px;
    color: #bbb;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
}

.news-list {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;
  overflow: hidden;

  li {
    display: flex;
    align-items: center;
    padding: 14px 0;
    border-bottom: 1px dashed #f5f5f5;
    cursor: pointer;
    transition: all 0.3s ease;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      padding-left: 8px;

      .news-date {
        background: #1890ff;
        color: #fff;
      }

      .news-title {
        color: #1890ff;
      }

      .news-arrow {
        color: #1890ff;
        transform: translateX(4px);
      }
    }
  }

  .news-date {
    font-size: 14px;
    color: #888;
    background: #f5f7fa;
    padding: 4px 10px;
    border-radius: 4px;
    flex-shrink: 0;
    margin-right: 14px;
    transition: all 0.3s ease;
  }

  .news-title {
    flex: 1;
    min-width: 0;
    font-size: 16px;
    color: #444;
    transition: color 0.3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .news-arrow {
    font-size: 16px;
    color: #ccc;
    flex-shrink: 0;
    margin-left: 10px;
    transition: all 0.3s ease;
  }

  .news-empty {
    justify-content: center;
    color: #bbb;
    font-size: 14px;
    border-bottom: none;
    cursor: default;

    &:hover {
      padding-left: 0;
    }
  }
}

.floors {

  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .img-banner {
    width: 50%;
    height: 380px;

    .cover-link {
      cursor: pointer;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 50%;
      height: 380px;
      z-index: 4;
      background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
    }

    // .cover-link:hover {
    //   box-shadow: inset 0 0 38px rgba(0, 0, 0, 0.18);
    //   transition: all .15s ease;
    // }
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.header-title {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  background-color: #0ca9d2;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
}

.item .p {
  background: #f56521;
  padding: 12px;
  text-align: center;
  border-radius: 10px;
  color: #fff;
}

.item.itme2 .p {
  background: #0ca9d2;
}


.link-panel {
  margin: 30px auto 0;
  position: relative;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
  position: relative;

  h1 {
    font-size: 28px;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0 0 8px 0;
    letter-spacing: 3px;
  }

  .title-en {
    font-size: 12px;
    color: #999;
    letter-spacing: 4px;
    text-transform: uppercase;
    font-weight: 300;
  }

  .title-bar {
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #1890ff, #36cfc9);
    margin: 16px auto 0;
    border-radius: 2px;
  }
}

.link-box {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 16px;
  background: transparent;
  border-radius: 16px;
  padding: 28px 0;
}

.link-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 12px 6px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.25s ease;

  &:hover {
    .link-icon-wrap {
      background: #1890ff;
      box-shadow: 0 4px 14px rgba(24, 144, 255, 0.35);
      transform: scale(1.08);
    }

    i {
      color: #fff;
    }

    span {
      color: #1890ff;
    }
  }

  .link-icon-wrap {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s ease;
    box-shadow: 6px -8px 8px -1px rgba(0, 0, 0, 0.1);
  }

  i {
    font-size: 36px;
    color: #1890ff;
    transition: all 0.25s ease;
  }

  span {
    font-size: 15px;
    color: #555;
    text-align: center;
    transition: color 0.25s ease;
    line-height: 1.3;
  }
}

// .activity-tip{
//   width: 300px;
//   height: 110px;
//   border-radius: 10px;
//   position: absolute;
//   top: -30%;
//   left: -23%;
//   img{
//     width: 250px;
//     height: 80px;
//   }
//   &:hover{
//     cursor: pointer;
//   }
// }
.matchContent{
  // margin: 15px;
  // color: #2c3e50;
  // font-size: 15px;
  position: relative;
}
.joinIcon{
  font-size: 40px;
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 5px;
  right: -5px;
}

.uploadButton{
  border-radius: 30px;
  border: 1px solid black;
  width: 230px;
  height: 50px;
  position: absolute;
  top: 55%;
  left: 40%;
  font-size: 25px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
  background-color: transparent; /* 可以根据需要调整背景颜色 */
  color: black; /* 可以根据需要调整文字颜色 */
  transition: background-color 0.3s ease, color 0.3s ease; /* 添加过渡效果 */
}
.uploadButton:hover{
  // background-color: rgba(#FC5531,0.2); /* 鼠标悬停时的背景颜色 */
  background-color: rgba(white,0.2); /* 鼠标悬停时的背景颜色 */
  color: #00a4d4; /* 鼠标悬停时的文字颜色 */
}
.el-icon-bottom-right{
  padding: 5px;
  border-radius: 5px;
  transition: 1.3s ease, color 1.3s ease; /* 添加过渡效果 */
}
.el-icon-bottom-right:hover{
  border: 1px solid #00a4d4;
}

/* ===== About Panel ===== */
.about-panel {
  margin-top: 50px;
}

.footer-main {
  display: flex;
  justify-content: space-between;
  padding: 48px 40px 36px;
  align-items: center;
  background: linear-gradient(180deg, #f5f5f5 0%, #ffffff 100%);
  border-radius: 12px;
  box-shadow: 0 12px 16px -4px rgba(0, 0, 0, 0.1);
}

.footer-intro {
  width: 720px;
  flex-shrink: 0;
  min-width: 0;

  h3 {
    font-size: 24px;
    font-weight: 600;
    color: #1a1a2e;
    margin: 0 0 18px 0;
    position: relative;
    padding-left: 14px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      width: 4px;
      height: 22px;
      background: linear-gradient(180deg, #1890ff, #36cfc9);
      border-radius: 2px;
    }
  }

  p {
    font-size: 17px;
    color: #555;
    line-height: 2;
    margin: 0 0 12px 0;
    text-indent: 2em;
  }
}

.footer-bottom {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  align-self: stretch; // 高度占满父级（覆盖父级 align-items: center）
  padding-left: 80px;
  gap: 20px;
}

.footer-qrcode {
  display: flex;
  gap: 24px;
  justify-content: center;

  .qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    position: relative;

    .qr-popup {
      position: absolute;
      bottom: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%) scale(0.8);
      opacity: 0;
      pointer-events: none;
      background: #fff;
      padding: 10px;
      border-radius: 10px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
      transition: all 0.3s ease;

      &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 6px solid transparent;
        border-top-color: #fff;
      }

      img {
        width: 150px;
        height: 150px;
        border-radius: 6px;
        object-fit: cover;
      }
    }

    &:hover .qr-popup {
      opacity: 1;
      transform: translateX(-50%) scale(1);
    }

    .qr-icon {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      background: #1890ff;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: box-shadow 0.3s ease;

      img {
        width: 54px;
        height: 54px;
        filter: brightness(0) invert(1);
        object-fit: contain;
      }
    }

    &:hover .qr-icon {
      box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
    }

    span {
      font-size: 14px;
      color: #666;
    }
  }
}

.footer-contact {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: fit-content;
  margin: 0 auto;

  .contact-item {
    display: flex;
    align-items: center;
    gap: 12px;

    i {
      font-size: 22px;
      color: #1890ff;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(24, 144, 255, 0.1);
      border-radius: 10px;
    }

    div {
      display: flex;
      flex-direction: column;
      gap: 4px;

      strong {
        font-size: 14px;
        color: #999;
        font-weight: normal;
      }

      span {
        font-size: 17px;
        color: #333;
        font-weight: 500;
      }
    }
  }
}

/* ===== Scroll Reveal Animation ===== */

// 统一动画：整个模块由小变大出现
.reveal-on-scroll {
  opacity: 0;
  transform: scale(0.8);
  transition: opacity 1.2s cubic-bezier(0.16, 1, 0.3, 1),
  transform 1.2s cubic-bezier(0.16, 1, 0.3, 1);

  &.revealed {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// home.vue?bf02dcd0